export default String.raw`
.empty-page {
    &__heading {
        h2 {
            @include h3-headline;
        }

        svg {
            width: 32px;
            height: 32px;
            margin-right: 16px;
        }
    }
}
`